import { colors } from '@mui/material';
export const ezColors = {
    white: colors.common.white,
    amber: colors.amber[500],
    deepOrange: colors.deepOrange[400],
    lightBlue: colors.lightBlue[500],
    indigo: colors.indigo[400],
    green: colors.green[500],
    teal: colors.teal['A400'],
    pink: colors.pink[500],
    red: colors.red[500],
    black: colors.common.black
};
//# sourceMappingURL=colors.js.map